import { render, staticRenderFns } from "./ChartCH.vue?vue&type=template&id=23be8c86&scoped=true"
import script from "./ChartCH.vue?vue&type=script&lang=js"
export * from "./ChartCH.vue?vue&type=script&lang=js"
import style0 from "./ChartCH.vue?vue&type=style&index=0&id=23be8c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be8c86",
  null
  
)

export default component.exports